import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from "primereact/inputtextarea";
import { Messages } from 'primereact/messages';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useCallback, useEffect, useRef, useState } from "react";
import 'react-slideshow-image/dist/styles.css';
import count_days from '../../functions/count_days';
import view_apartment_type_ar from '../../functions/view_apartment_type';
import view_day_ar from '../../functions/view_day_ar';
import { _endPoints, baseUrl } from '../../Helper/links';
import pattern from '../../Helper/pattern';
import API from '../../Helper/server/API';
import { useWhatsapp } from '../../whatsapp/WhatsappContext';
import { InvoiceContext } from '../invoice/Invoice_Context';
import InvoiceCustomer from '../invoice/invoice_customer';

function BookingEditConfirmStep({ bookingData, setbookingApartmentData, bookingCustomerData, setbookingCustomerData }) {
    const toast = useRef(null);
    const msgs = useRef(null);
    const { SendWhatsAppMsg } = useWhatsapp();

    const [dataPaid, setDataPaid] = useState(null);
    const [InvoicePaid, setInvoicePaid] = useState(false);

    const [loding, set_loding] = useState(false)
    // eslint-disable-next-line no-unused-vars
    const [reservation, set_reservation] = useState(bookingData);
    const [customerData, setcustomerData] = useState(bookingCustomerData);
    const [loading_handel_3, set_loading_handel_3] = useState(true);

    const items = Array.from({ length: 5 }, (v, i) => i);

    const handel_discount_value = useCallback((value, item) => {
        if (
            value !== '' && value !== null
            && pattern.number_int.test(value) === true
            && value <= (reservation.price_day * count_days([reservation]))
        ) {
            set_reservation({ ...reservation, discount_value: value, total_price: ((reservation.price_day * count_days([reservation])) - value) })

        }
        else {
            set_reservation({ ...reservation, discount_value: 0, total_price: ((reservation.price_day * count_days([reservation])) - 0) })
        }
    }, [reservation]);
    const handel_notes = useCallback((value) => {
        if (
            (value || value === '' || value === null)
            &&
            value.length <= 1000
            &&
            pattern.notes.test(value) === true
        ) {
            set_reservation({ ...reservation, notes: value })
        }
    }, [reservation]);
    const handel_date_del_reservation = useCallback((e) => {
        if (reservation.total_paid === 0) {
            if (reservation.date_del_reservation)
                set_reservation({ ...reservation, date_del_reservation: false })
            else
                set_reservation({ ...reservation, date_del_reservation: true })
        }
    }, [reservation]);

    const UpdateBooking = async (e) => {
        set_loding(true)
        if (!customerData.ID_customer || pattern.number_int.test(customerData?.ID_customer) === false) {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: 'أرجــو أختيــار العميــل'
            });
        }
        else if (!reservation) {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: 'أرجــو أختيــار نــوع الإقــامة'
            });
        }
        else {
            var date_send = {
                ID_customer: customerData.ID_customer,
                reservation: reservation
            }
            const response = await API.post(_endPoints.reservations.update, date_send)
            if (response?.success === 1) {
                SendWhatsAppMsg(_endPoints.whatsapp.new_booking, {
                    ID_customer: customerData?.ID_customer,
                    status_booking: "edit"
                })
                set_loading_handel_3(true)

                set_reservation(null)
                // setbookingApartmentData({})
                setcustomerData({})
                setbookingCustomerData({})
                setDataPaid(response)
                setInvoicePaid(true)
            }
            else if (response?.success === 0) {
                toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'error', summary: 'خطــاء', detail: response?.msg
                });
            }
        }
        set_loding(false)
    }
    useEffect(() => {
        if (!customerData?.ID_customer) {
            msgs.current.show([
                { severity: 'error', detail: '', summary: "يرجى اختيار العميل لإتمام عملية تعديل الحجز.", sticky: true, closable: false }
            ]);
        }
        if (reservation?.ID_reservation) {
            set_loading_handel_3(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <div class="ibox">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
                <div className="ibox invoice-print" >
                    <div className="invoice-header">
                        <div>
                            <div className="col-md-12">
                                <div className="row font-15">
                                    <div className="col-md-6 " style={{ border: "1px solid rgba(0,0,0,.1" }}>
                                        <div className="m-b-5 font-bold mt-4 " >بيـــانات العميـــل</div>
                                        <hr></hr>

                                        <div className="m-b-5 font-bold" >
                                            <i class="ti-user font-26 text-muted ml-2" dir='rtl'></i> {customerData?.visitor_name ? customerData?.visitor_name : <>-</>}
                                        </div>
                                        <div className="m-b-5 font-bold pt-1" >
                                            <i class="fa fa-phone font-26 text-muted ml-3 "></i>
                                            {customerData?.phone_number ?
                                                <>{customerData?.phone_number} <small class=" text-muted" dir='ltr' > +218 </small></>
                                                : <>-</>}
                                        </div>
                                        <div className="m-b-5 font-bold pt-1" >
                                            <i class="fa fa-whatsapp font-26 text-muted ml-3 "></i>
                                            {customerData?.whatsapp_number && customerData?.whatsapp_number !== 'null' ?
                                                <>{customerData.whatsapp_number} +</>
                                                : <>-</>}
                                        </div>
                                    </div>

                                    <div className="col-md-6 " style={{ border: "1px solid rgba(0,0,0,.1" }}>
                                        <div className="m-b-5 font-bold mt-4 " >بيانات الحجــوزات</div>
                                        <hr></hr>
                                        <div className="m-b-5 font-bold" >
                                            <span className="font-strong"> عـدد الحجــوزات : </span>
                                            1
                                        </div>
                                        <div className="m-b-5 font-bold pt-3" >
                                            <span className="font-strong"> إجمــالي الأيـــام : </span>
                                            {reservation ? count_days([reservation]) : null}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        {
                            loading_handel_3 ?
                                <>
                                    <div className="col-md-12" >
                                        <div className="card p-0 m-0" >
                                            <DataTable value={items} className="p-datatable-striped p-0 m-0" style={{ width: '100%' }}>
                                                <Column style={{ width: '25%', height: "60px" }} headerStyle={{ height: "50px" }} body={<Skeleton height='20px' />}></Column>
                                                <Column style={{ width: '25%' }} body={<Skeleton height='20px' />}></Column>
                                                <Column style={{ width: '25%' }} body={<Skeleton height='20px' />}></Column>
                                                <Column style={{ width: '25%' }} body={<Skeleton height='20px' />}></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </>
                                :
                                <div className='col-md-12'>
                                    <div class="table-responsive">
                                        <table className="table table-bordered table-striped no-margin table-invoice" style={{ width: "100%" }}>
                                            <thead className="color-view bg-ebony" style={{ fontSize: "15px" }}>
                                                <tr style={{ color: "white" }}>
                                                    <th style={{ width: "10%" }}>الحجز</th>
                                                    <th style={{ width: "10%" }}>الاقامة</th>
                                                    <th colSpan={2} style={{ textAlign: "center", width: "25%" }} >
                                                        الأستــلام - المغــادرة
                                                    </th>
                                                    <th style={{ width: "5%" }}>المـدة</th>
                                                    <th style={{ width: "10%" }}>سعر اليـوم</th>
                                                    <th style={{ width: "10%" }}>الإجمــالي</th>
                                                    <th style={{ textAlign: "center", width: "5%" }}>قيمــة الخصــم</th>
                                                    <th style={{ width: "20%" }}>الإجمــالي بعــد الخصــم</th>
                                                    <th style={{ textAlign: "center", width: "5%" }}>ملاحظات</th>
                                                    <th style={{ textAlign: "center", width: "10%" }}>نوع </th>

                                                </tr>
                                            </thead>
                                            <tbody style={{ fontSize: "15px" }} >
                                                {
                                                    reservation ?
                                                        <tr >
                                                            <td style={{ verticalAlign: "middle" }}>
                                                                {reservation?.ID_reservation}
                                                            </td>
                                                            <td style={{ verticalAlign: "middle" }}>
                                                                <div>
                                                                    <small>{view_apartment_type_ar(reservation.type)}</small><strong>{"-" + reservation?.number}</strong>
                                                                </div>
                                                                <small>{reservation.number_people} أشخاص </small>
                                                            </td>
                                                            <td style={{ verticalAlign: "middle" }}>
                                                                <div>
                                                                    <strong >{reservation.date_check_in} </strong>
                                                                </div>
                                                                <small> {view_day_ar(reservation.date_check_in)} </small>
                                                            </td>
                                                            <td style={{ verticalAlign: "middle" }}>
                                                                <div>
                                                                    <strong>{reservation.date_check_out}  </strong>
                                                                </div>
                                                                <small>  {view_day_ar(reservation.date_check_out)} </small>
                                                            </td>
                                                            <td style={{ verticalAlign: "middle" }}>{count_days([reservation])} أيام</td>
                                                            <td style={{ verticalAlign: "middle" }}>{reservation.price_day}  د.ل</td>
                                                            <td style={{ verticalAlign: "middle" }}><strong >{(reservation.price_day * count_days([reservation]))} د.ل</strong></td>
                                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                <InputNumber value={reservation.discount_value}
                                                                    onChange={(e) => handel_discount_value(e.value)}
                                                                    style={{ fontFamily: "Cairo" }}
                                                                    min={0}
                                                                    className='col-md-8'
                                                                    inputId='discount_value'
                                                                ></InputNumber>
                                                            </td>
                                                            <td style={{ verticalAlign: "middle" }}><strong >{(reservation.price_day * count_days([reservation])) - reservation.discount_value} د.ل</strong></td>
                                                            <td style={{ verticalAlign: "middle" }}>
                                                                <InputTextarea maxLength={1000} value={reservation.notes}
                                                                    onChange={(e) => handel_notes(e.target.value)}
                                                                />
                                                            </td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                <Button icon={reservation.date_del_reservation ? "pi pi-clock" : "pi pi-check-circle"} rounded text severity={reservation.date_del_reservation ? "danger" : "success"}
                                                                    onClick={(e) => handel_date_del_reservation(e)}
                                                                />
                                                                <br></br>
                                                                <span>{reservation.date_del_reservation ? 'مبــدئي' : 'مـــؤكد'}</span>
                                                            </td>

                                                        </tr>
                                                        : null
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <table className="table no-border">
                                        <thead >
                                            <tr>
                                                <td className="font-bold font-18 text-center">إجمالي المبلغ  </td>
                                                <td className="font-bold font-18 text-center">إجمالي المدفوع  </td>
                                                <td className="font-bold font-18 text-center">إجمالي المتبقي  </td>
                                            </tr>
                                        </thead>
                                        <tbody  >
                                            <tr>
                                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>
                                                    {Intl.NumberFormat("en-US").format(reservation.total_price)} د.ل
                                                </td>
                                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>
                                                    {Intl.NumberFormat("en-US").format(reservation.total_paid)} د.ل
                                                </td>
                                                <td className="font-bold font-18 text-center" style={{ padding: "1px", color: "red" }}>
                                                    {
                                                        reservation.total_paid * 1 >= reservation.total_price * 1 ?
                                                            (
                                                                <strong style={{ color: "green" }}>
                                                                    خالص
                                                                </strong>
                                                            )
                                                            :
                                                            (
                                                                <strong style={{ color: "red" }}>
                                                                    {Intl.NumberFormat("en-US").format(reservation.total_price - reservation.total_paid)} د.ل
                                                                </strong>
                                                            )
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {
                                        reservation.total_paid > reservation.total_price ?
                                            (
                                                <>
                                                    <hr></hr>
                                                    <center>
                                                        <h5 id="msg_rest" style={{ fontSize: "18px" }}>
                                                            القيمة المسترجعة
                                                        </h5>
                                                        <h5 id="rest" style={{ fontSize: "18px", color: "red" }}>
                                                            {Intl.NumberFormat("en-US").format(reservation.total_price - reservation.total_paid)} د،ل
                                                        </h5>
                                                    </center>
                                                </>
                                            ) : null
                                    }
                                </div>
                        }
                        <div className='col-md-12 p-5'>
                            <center>
                                <Messages ref={msgs} style={{ width: "30%" }} />
                                <Button label="تعــديل الحجـــز" raised severity='success' style={{ fontFamily: "Cairo", width: "30%" }} disabled={loading_handel_3 || !customerData?.ID_customer || !reservation ? true : false}
                                    onClick={UpdateBooking} loading={loding}
                                />
                            </center>
                        </div>
                    </div>
                </div>
            </div>

            {
                InvoicePaid ?
                    (
                        <>
                            <Dialog dir="rtl" header="فاتورة الحجوزات" visible={true} maximizable style={{ width: '60vw', fontFamily: "Cairo" }} onHide={() => setInvoicePaid(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                                <InvoiceContext.Provider value={dataPaid} >
                                    {dataPaid && <InvoiceCustomer></InvoiceCustomer>}
                                </InvoiceContext.Provider>
                            </Dialog>
                        </>
                    )
                    :
                    (null)
            }
        </div>
    )
}

export default BookingEditConfirmStep